/* eslint-disable jira/filename-case */

import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('require_ai_enabled_for_jsm_virtual_agent');
	},
};
